import axios from "axios";

export interface Wage {
  id: number;
  name: string;
}

export async function getAllWageTypes() {
  return axios
    .get<Wage[]>(`/UserWageTypes/getwagetypeall`)
    .then((res) => res.data);
}
